import {
  IRequestCallbackRequestSchema,
  IRequestCallbackResponseSchema,
} from '@cian/api-models/monolith-python/api/callback/add';
import { CallbackForm, CallbackModal } from '@cian/callback-widget';
import { IHttpApi } from '@cian/http-api';
import * as React from 'react';
import { requestCallback } from '../../../api/callback';
import * as PropTypes from 'prop-types';

export interface ICallbackModalProps {
  agentPhone: string;
  callFrom?: string;
  callTo?: string;
  close(): void;
  gaLabel: string;
  httpApi: IHttpApi;
  isAvailableToCall?: boolean;
  timezoneText?: string;
  useOldWidget?: boolean;
}

export interface ICallbackModalContainerContext {
  currentSubdomain: string;
  httpApi: IHttpApi;
}

export class CallbackModalContainer extends React.Component<ICallbackModalProps> {
  public context: ICallbackModalContainerContext;
  private container: HTMLDivElement | null = null;
  private requestCallback: (options: IRequestCallbackRequestSchema) => Promise<IRequestCallbackResponseSchema>;

  public static contextTypes = {
    httpApi: PropTypes.object,
    currentSubdomain: PropTypes.string,
  };

  public constructor(props: ICallbackModalProps) {
    super(props);

    if (document) {
      this.container = document.createElement('div');
      document.body.appendChild(this.container);
    }
  }

  public componentDidMount() {
    const subdomain = this.context.currentSubdomain || 'www';

    this.requestCallback = requestCallback(subdomain).bind(this, this.props.httpApi);
  }

  public componentWillUnmount() {
    if (document && this.container) {
      document.body.removeChild(this.container);
    }
  }

  public render() {
    if (!this.container) {
      return null;
    }

    return (
      <CallbackModal
        root={this.container}
        close={this.props.close}
      >
        <CallbackForm
          close={this.props.close}
          requestCallback={this.requestCallback}
          agentPhone={this.props.agentPhone}
          isTimezoneMode={!this.props.useOldWidget}
          sendAnalytics={false}
          callFrom={this.props.callFrom}
          callTo={this.props.callTo}
          timezoneText={this.props.timezoneText}
          isNightMode={!this.props.isAvailableToCall}
        />
      </CallbackModal>
    );
  }
}
